// extracted by mini-css-extract-plugin
export default {"block":"Account_block__e2r1K"};